import { useState, useEffect, useMemo } from 'react';
import { Entity } from '@backstage/catalog-model';
import { useRelatedEntities } from '@backstage/plugin-catalog-react';
import { RELATION_DEPENDENCY_OF } from '@backstage/catalog-model';
import { parseEnvironmentsAnnotation, GITLAB_ANNOTATIONS } from '../gitlab';
import type { GitLabEnvironment } from '../gitlab';

interface UseEnvironmentsResult {
  component: Entity | undefined;
  environments: GitLabEnvironment[] | null;
  selectedEnv: string | null;
  setSelectedEnv: (env: string) => void;
}

export function useEnvironments(entity: Entity): UseEnvironmentsResult {
  const { entities: linkedComponents } = useRelatedEntities(entity, {
    type: RELATION_DEPENDENCY_OF,
    kind: 'component',
  });

  const component = linkedComponents?.[0];

  const environments = useMemo(() => {
    if (!component) return null;
    const annotation = component.metadata.annotations?.[GITLAB_ANNOTATIONS.ENVIRONMENTS];
    return parseEnvironmentsAnnotation(annotation);
  }, [component]);

  const [selectedEnv, setSelectedEnv] = useState<string | null>(null);

  useEffect(() => {
    if (environments && environments.length > 0 && !selectedEnv) {
      setSelectedEnv(environments[0].name);
    }
  }, [environments, selectedEnv]);

  return { component, environments, selectedEnv, setSelectedEnv };
}
